export function formatAmount(amount, currencyData) {
    const locale = currencyData.currencyLocale
    const name = currencyData.currencyName
    return Intl.NumberFormat(locale, {style: 'currency', currency: name}).format(amount/100.0)
}